import { Component, Inject, OnInit } from '@angular/core';
import { UtilsService } from '../../../shared/utils.service';
import { AppService } from '../../../app.service';
import { AssetsService } from '../../assets.service';
import { AssetMaintenanceRecordsService } from '../asset-maintenance-records.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  NetworkedAccountsSelectorComponent
} from '../../../shared/networked-accounts-selector/networked-accounts-selector.component';
import { VendorsSelectorComponent } from '../../../shared/vendors-selector/vendors-selector.component';
import {
  NetworkedUsersSelectorComponent
} from '../../../shared/networked-users-selector/networked-users-selector.component';
import { AssetMaintenanceRecordsFilters } from './asset-maintenance-records-filter.interface';
import { faHardHat } from '@fortawesome/free-solid-svg-icons';
import {
  AssetMaintenanceSchedulesSelectorComponent
} from '../../asset-maintenance-schedules/asset-maintenance-schedules-selector/asset-maintenance-schedules-selector.component';

@Component({
  selector: 'app-asset-maintenance-records-filter',
  templateUrl: './asset-maintenance-records-filter.component.html',
  styleUrls: ['./asset-maintenance-records-filter.component.scss']
})
export class AssetMaintenanceRecordsFilterComponent implements OnInit {
  asset_id: number;

  filters: AssetMaintenanceRecordsFilters = {
    archived: 'false',
    schedule_ids: [],
    contractor_ids: [],
    vendor_ids: [],
    user_ids: [],
    status: 'all',
    type: 'all',
    priority: 'all',
    date_type: 'due_at',
    date_range: []
  };

  typeOptions = this.utils.toOptions(this.assetMaintenanceRecordsService.TYPES);
  priorityOptions = this.utils.toOptions(
    this.assetMaintenanceRecordsService.PRIORITIES
  );
  statusOptions = this.utils.toOptions(
    this.assetMaintenanceRecordsService.STATUSES
  );

  faHardHat = faHardHat;

  constructor(
    public utils: UtilsService,
    public app: AppService,
    public assetsService: AssetsService,
    public assetMaintenanceRecordsService: AssetMaintenanceRecordsService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<AssetMaintenanceRecordsFilterComponent>
  ) {}

  ngOnInit() {
    this.asset_id = this.data['asset_id'] || 0;

    this.filters.archived = this.data['archived'] || 'false';
    this.filters.schedule_ids = this.data['schedule_ids'] || [];
    this.filters.contractor_ids = this.data['contractor_ids'] || [];
    this.filters.vendor_ids = this.data['vendor_ids'] || [];
    this.filters.user_ids = this.data['user_ids'] || [];
    this.filters.status = this.data['status'] || 'all';
    this.filters.type = this.data['type'] || 'all';
    this.filters.priority = this.data['priority'] || 'all';
    this.filters.date_type = this.data['date_type'] || 'due_at';
    this.filters.date_range = this.data['date_range'] || [];
  }

  /**
   * Sets the output date range based on the provided event value.
   *
   * @param event
   * @return {void} - No return value.
   */
  getOutputDateRange(event: any): void {
    this.filters.date_range = event;
  }

  /**
   * Select asset maintenance schedules and update the schedule IDs filters.
   *
   * @return {void}
   */
  onSelectSchedules(): void {
    this.utils.showComponentDialog(
      AssetMaintenanceSchedulesSelectorComponent,
      {
        asset_id: this.asset_id,
        selected: this.filters.schedule_ids,
        multiple: true,
        required: false
      },
      {
        width: '1500px'
      },
      (results: number[]) => {
        if (!results) {
          return;
        }
        this.filters.schedule_ids = results;
      }
    );
  }

  /**
   * Select contractors and update the contractor IDs filters.
   *
   * @return {void}
   */
  onSelectContractors(): void {
    this.utils.showComponentDialog(
      NetworkedAccountsSelectorComponent,
      {
        selected: this.filters.contractor_ids,
        multiple: true
      },
      {
        width: '1200px'
      },
      (results: number[]) => {
        if (!results) {
          return;
        }
        this.filters.contractor_ids = results;
      }
    );
  }

  /**
   * Select vendors and update the vendor IDs filters.
   *
   * @return {void}
   */
  onSelectVendors(): void {
    this.utils.showComponentDialog(
      VendorsSelectorComponent,
      {
        selected: this.filters.vendor_ids,
        multiple: true,
        required: false
      },
      {
        width: '1200px'
      },
      (results: number[]) => {
        if (!results) {
          return;
        }
        this.filters.vendor_ids = results;
      }
    );
  }

  /**
   * Select networked users and update the user IDs filters.
   *
   * @return {void}
   */
  onSelectUsers(): void {
    this.utils.showComponentDialog(
      NetworkedUsersSelectorComponent,
      {
        selected: this.filters.user_ids,
        multiple: true,
        selectedAccountId: this.app.account.id,
        visitors_from_all_sites: true
      },
      {
        width: '1200px'
      },
      (results: number[]) => {
        if (!results) {
          return;
        }
        this.filters.user_ids = results;
      }
    );
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    this.filters.archived = 'false';
    this.filters.schedule_ids = [];
    this.filters.contractor_ids = [];
    this.filters.vendor_ids = [];
    this.filters.user_ids = [];

    this.filters.status = 'all';
    this.filters.type = 'all';
    this.filters.priority = 'all';

    this.filters.date_type = 'due_at';
    this.filters.date_range = [];

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    this.dialogRef.close(this.filters);
  }

  /**
   * Closes the dialog.
   *
   * @return {void}
   */
  onClose(): void {
    this.dialogRef.close();
  }

  /**
   * Clears the date range for this filter.
   *
   * @return {void}
   */
  onClearDateRange(): void {
    this.filters.date_range = [];
  }
}
